// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"0f175796","577":"3b78ae8e","917":"23a1f581"}[chunkId] + ".chunk.js";
};